// Posts per blog listing page. Shared by the client list and the prerendered
// /blog/page/<n> routes, so it lives outside the "use client" component.
export const BLOG_PAGE_SIZE = 17;
